<template>
    <div class="col-md-12">
        <ManageGroups></ManageGroups>
        <ManagePriorities></ManagePriorities>
        <ManageStatus></ManageStatus>
    </div>
</template>

<script>
import ManageGroups from './groups/ManageGroups.vue';
import ManagePriorities from './prioritires/ManagePriorities.vue';
import ManageStatus from './statuses/ManageStatus.vue';

export default {
    name: "ConfigTickets",
    components: {
        ManageGroups,
        ManagePriorities,
        ManageStatus
    },
    data() {
        return {}
    },
    created() {},
    methods: {
    }
}
</script>